import { render, staticRenderFns } from "./courseDesc.vue?vue&type=template&id=17e1ffcc&scoped=true&"
import script from "./courseDesc.vue?vue&type=script&lang=js&"
export * from "./courseDesc.vue?vue&type=script&lang=js&"
import style0 from "./courseDesc.vue?vue&type=style&index=0&id=17e1ffcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e1ffcc",
  null
  
)

export default component.exports